import type { UseMutationResult } from "@tanstack/react-query"
import { useMutation, useQueryClient } from "@tanstack/react-query"

import { queryKeys } from "~/api/cache"

import { invalidateBatteryPrice } from "./battery-price-dependents"
import type {
  BatteryProposalFinancingDto,
  CalculateBatteryPaymentDto,
} from "../dto/battery-proposal.dto"
import { batteryProposalService } from "../services/battery-proposal.service"

/**
 * Save & Calculate Payment: the one command that saves a Loan Product and
 * runs Battery pricing. Everything derived from the stored Battery price moves
 * with it.
 */
export default function useCalculateBatteryPayment(): UseMutationResult<
  BatteryProposalFinancingDto,
  unknown,
  { proposalId: string; body: CalculateBatteryPaymentDto }
> {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({ proposalId, body }) =>
      batteryProposalService.calculatePayment(proposalId, body),
    onError: (_error, { proposalId }) => {
      invalidateBatteryPrice(queryClient, proposalId)
    },
    onSuccess: (financing, { proposalId }) => {
      // The response is the financing read after saving and pricing.
      queryClient.setQueryData(
        queryKeys.batteryProposal.financing(proposalId),
        financing,
      )
      invalidateBatteryPrice(queryClient, proposalId)
    },
  })
}
